
/**
 * Changes made:
 * - 2024-09-07: Added proper component implementation with default export
 * - 2024-09-08: Fixed export syntax to ensure proper module resolution
 * - 2024-03-28: Fixed component to ensure proper rendering
 * - 2025-05-05: Fixed IndexPage structure and added RealtimeProvider
 * - 2025-04-29: Removed unnecessary import causing nested provider issues
 * - 2025-05-01: Verified component is correctly exporting as default for routing
 * - 2025-05-21: Updated component to ensure it renders properly as root route
 * - 2025-05-22: Fixed navigation spacing to ensure hero section appears correctly
 * - 2025-05-24: Fixed layout and content rendering to resolve blank page issue
 * - 2025-06-17: Removed BottomCTA component completely as it's no longer needed
 * - 2026-06-30: Removed VideoTutorial section due to business model change
 * - 2026-02-16: Added SellerReviewsDisplay between Partners and HowItWorks
 * - 2026-02-26: Removed PromoBanner (VIN i WIN promo ended)
 */

import React, { useEffect } from 'react';
import { Hero } from '@/components/Hero';
import { Partners } from '@/components/Partners';
import { SellerReviewsDisplay } from '@/components/SellerReviewsDisplay';
import { HowItWorks } from '@/components/HowItWorks';

import { Benefits } from '@/components/Benefits';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';

import { SEO } from '@/components/SEO';

const IndexPage = () => {
  return (
    <>
      <SEO 
        title="Autaro.pl – Darmowa sprzedaż samochodu online w Polsce"
        description="Szybka, bezpieczna i darmowa sprzedaż samochodu online. Wpisz VIN, otrzymaj wycenę, a my przedstawimy Ci najwyższą ofertę od zweryfikowanych komisów."
        canonicalUrl="https://www.autaro.pl/"
      />
      <div className="min-h-screen bg-white flex flex-col">
        <Navigation />
        
        <main className="flex-grow">
          <Hero />
          <Partners />
          <SellerReviewsDisplay />
          <HowItWorks />
          
          <Benefits />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default IndexPage;
